export const EXCEL_UTF8_BOM = '\uFEFF';

export const escapeExcelCsvCell = value => {
  const text = value == null ? '' : String(value);
  if (/[;"\r\n]/.test(text)) return `"${text.replace(/"/g, '""')}"`;
  return text;
};

export const withExcelBom = content => {
  const payload = content == null ? '' : String(content);
  if (payload.charCodeAt(0) === 0xfeff) return payload;
  return `${EXCEL_UTF8_BOM}${payload}`;
};

const excelRows = rows =>
  rows.map(row => row.map(escapeExcelCsvCell).join(';')).join('\r\n');

export const buildExcelCsv = rows => withExcelBom(excelRows(rows));
